// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18gKs","colBig":"styles_colBig__2W5Tw","colSmall":"styles_colSmall__2MKVM","shopifyNameWrapper":"styles_shopifyNameWrapper__1PlTp"};